import { ISliderStyles } from "@fluentui/react";
import {
  concatStyleSets,
  ITheme,
  mergeStyleSets,
} from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import {
  baseFabricFocusAfterSelector,
  controlStylingConstants,
  getInnerBorderStyles,
  getStandardControlSemanticColorsWithTheme,
  StandardControlSemanticColors,
  textContainerClassName,
} from "@1js/acui-common";

import { AppSliderStyles } from "./AppSlider.Props";

export interface SliderClassNames {
  root: string;
  text: string;
}

export const getClassNames = memoizeFunction(
  (
    disabled: boolean | undefined,
    customStyles?: AppSliderStyles
  ): SliderClassNames => {
    const controlHeight = controlStylingConstants.controlHeight;
    return mergeStyleSets(
      {
        root: {
          display: "flex",
          width: 300,
          textAlign: "center",
          height: controlHeight,
        },
        text: [
          textContainerClassName,
          {
            flex: "0 1 0px",
            lineHeight: controlHeight,
            fontSize: 12,
            padding: "0 3px",
            color: disabled ? "#C8C8C8" : undefined,
          },
        ],
      },
      customStyles
    );
  }
);

export const getSliderStyles = memoizeFunction(
  (theme: ITheme, customStyles?: AppSliderStyles): Partial<ISliderStyles> => {
    const controlHeight = controlStylingConstants.controlHeight;
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const defaultSliderStyles: Partial<ISliderStyles> = {
      root: {
        flex: "1 0 0px",
        display: "grid",
        height: controlHeight,
      },
      slideBox: {
        selectors: {
          [`${baseFabricFocusAfterSelector}`]: [
            getInnerBorderStyles({
              width: 2,
              color: standardControlSemanticColors.focusedBorderColor,
              gap: 0,
            }),
            { outline: "transparent" },
          ],
        },
      },
    };
    return concatStyleSets(defaultSliderStyles, customStyles?.slider);
  }
);
